import React, { useEffect, useState } from 'react'
import * as RegrasFaturamentoHttp from '../../../../../services/api/https/registration/regras-frete.http'
import { connect } from 'react-redux'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  InputText,
} from '../../../../../components'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  INIT: 'Adquirindo informações iniciais',
  SAVE: 'Salvando regra de frete',
  SUCCESS: 'Regra de Frete salvo com sucesso',
}

const INITIAL_STATE = {
  regrasFaturamento: {
    id: undefined,
    name: '',
    type: '',
    actived: true,
  },
  selectedTipo: null,
  savedRegrasFaturamento: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export const TIPO_REGRA = [
  {
    nome: '%Faturamento',
    id: '%Faturamento',
  },
  {
    nome: 'R$/KG',
    id: 'R$/KG',
  },
  { nome: 'R$/Vol', id: 'R$/Vol' },
  { nome: 'Valor Fixo', id: 'Valor Fixo' },
]

const RegrasFaturamentoModal = ({
  show,
  onModalClose,
  onModalSave,
  data,
  selectedTp,
  dispatch,
}) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const saveRegrasFaturamento = async regrasFaturamento => {
    try {
      let res = null
      if (regrasFaturamento.id)
        res = await RegrasFaturamentoHttp.updateRegrasFaturamento(regrasFaturamento)
      else res = await RegrasFaturamentoHttp.saveRegrasFaturamento(regrasFaturamento)
      setState(prevState => ({
        ...prevState,
        savedRegrasFaturamento: res,
        loadingMessage: LOAD_MESSAGE.SUCCESS,
      }))
    } catch (err) {
      setState(prevState => ({
        ...prevState,
        errorMessage: errorHandler(err),
        loadingMessage: LOAD_MESSAGE.NONE,
      }))
    }
  }

  // Events
  const onBtnSalvarClicked = async () => {
    // Validação dos campos obrigatórios
    if (!state.regrasFaturamento.name || !state.regrasFaturamento.name.trim()) {
      setState(prevState => ({
        ...prevState,
        errorMessage: 'O campo Nome é obrigatório',
      }))
      return
    }

    if (!state.selectedTipo) {
      setState(prevState => ({
        ...prevState,
        errorMessage: 'O campo Tipo de Cobrança é obrigatório',
      }))
      return
    }

    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  const onFormContentChange = (name, value) => {
    setState(prevState => {
      prevState.regrasFaturamento[name] = value
      return { ...prevState }
    })
  }

  // Helpers
  const fetchInitInfo = regrasFaturamento => {
    if (regrasFaturamento) {
      delete regrasFaturamento.created_at
      delete regrasFaturamento.updated_at
      return setState(prevState => ({
        ...prevState,
        regrasFaturamento: regrasFaturamento,
        selectedTipo: TIPO_REGRA.find(tipo => tipo.id === regrasFaturamento.type),
        loadingMessage: LOAD_MESSAGE.INIT,
      }))
    }
    setState(prevState => ({
      ...prevState,
      regrasFaturamento: { ...INITIAL_STATE.regrasFaturamento },
      loadingMessage: LOAD_MESSAGE.INIT,
    }))
  }

  const resetModal = () => {
    setState({ ...INITIAL_STATE })
  }

  //Hooks
  useEffect(() => {
    if (show) fetchInitInfo(data)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        const formattedRegrasFaturamento = {
          ...state.regrasFaturamento,
          type: state.selectedTipo.id,
          tp_id: selectedTp,
        }
        saveRegrasFaturamento(formattedRegrasFaturamento)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedRegrasFaturamento)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Regra de Faturamento"
      isVisible={show}
      onClose={() => {
        resetModal()
        onModalClose()
      }}
      width={800}
    >
      <form className="p-grid">
        <div className="p-col-8">
          <InputText
            marginTop={10}
            label="Nome:*"
            value={state.regrasFaturamento.name}
            onChange={value => onFormContentChange('name', value.toUpperCase())}
          />
        </div>

        <div className="p-col-4">
          <CustomDropdown
            optionLabel="nome"
            options={TIPO_REGRA}
            value={state.selectedTipo}
            label="Tipo de Cobrança:*"
            onChange={value => {
              setState(prevState => {
                prevState.selectedTipo = value
                return { ...prevState }
              })
            }}
          />
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            checked={state.regrasFaturamento.actived}
            onChange={value => onFormContentChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(RegrasFaturamentoModal)
